// extracted by mini-css-extract-plugin
export default {"imgStyle":"InitialLoadUI_imgStyle__d8Ztg"};